import { render, staticRenderFns } from "./ConnectFoundry.vue?vue&type=template&id=33938b86&"
import script from "./ConnectFoundry.vue?vue&type=script&lang=js&"
export * from "./ConnectFoundry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports